import { useSelector } from 'react-redux'
import FormPersonalDetailDetail from '../../employees/pim-detail/employee-info/personal-details/form-detail'

export default function ProfilePersonalDetails() {
  const profile = useSelector((state) => state.loginReducer.profile)
  const orgId = profile.org_id
  const code = profile.code

  return <FormPersonalDetailDetail orgId={orgId} code={code} btn_edit={true} />
}
